import React, { useEffect, useState } from 'react';
import '../Login.css';
import { sendAsyncRequest } from '../../../services/AsyncRequestService';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'components/Spinner';
import Alert from 'react-bootstrap/Alert';

const CognitoLogin = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleLogin = () => {
      let url = "/login";
      let method = "GET";
      sendAsyncRequest(url, method, null, onLoginSuccess, onLoginFailure);
    };

    const onLoginSuccess = (response) => {
      window.location = response.data;
    };

    const onLoginFailure = (error) => {
      setError("Something went wrong");
    };

    handleLogin();
  }, []);

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col className="text-align-center" md={{ span: 4, offset: 4 }}>
            {error ? <Alert variant="danger">{error}</Alert> : <Spinner />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CognitoLogin;